import { Slot } from '@radix-ui/react-slot'
import { cn } from '@seen/ui'
import type { ComponentPropsWithoutRef, JSX } from 'react'

export interface FacesheetCardIconProps extends ComponentPropsWithoutRef<'div'> {
  // Style the child itself instead of wrapping it. Cards whose marker is a
  // portrait need this: an Avatar already *is* a round chip, so wrapping it
  // would nest a chip inside a chip.
  asChild?: boolean
}

// The section's glyph. No bordered, shadowed chip so the glyph reads as a
// quiet marker rather than a second focal point — that emphasis belongs to
// FacesheetCardAddButton.
export function FacesheetCardIcon({
  className,
  asChild = false,
  ...delegated
}: FacesheetCardIconProps): JSX.Element {
  const Comp = asChild ? Slot : 'div'

  return (
    <Comp
      className={cn(
        'grid size-4 shrink-0 place-items-center text-foreground-secondary [&>svg]:size-3.5',
        className
      )}
      {...delegated}
    />
  )
}
